import { useQueueStatus } from "../core/useQueueStatus.js";

/**
 * Bandeau d'état réseau / file hors-ligne : invisible quand tout est synchronisé, sinon indique le
 * nombre d'opérations de capture en attente d'envoi (rejouées automatiquement au retour du réseau).
 */
export function OfflineBanner() {
  const { online, pending } = useQueueStatus();
  if (online && pending === 0) return null;
  const text = !online
    ? `Hors ligne — ${pending} en attente d'envoi`
    : `Envoi en cours — ${pending} en attente`;
  return <div className={"netbanner" + (online ? "" : " offline")}>{text}</div>;
}
